import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Route, Routes, useMatch, useLocation } from "react-router-dom";
import { AuthContext, AuthProvider } from "./contexts/AuthContext";
import ToastMessage from "./components/alert/toastMessage";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ProtectedRoute from "./components/protectedRoute/ProtectedRoute";
import LoaderProfile from "./components/loader/utilisateur/LoaderProfile";
import AdminRoute from "./components/protectedRoute/AdminRoute";
import Header from "./components/header/Header";
import Login from "./pages/authentification/Login";
import Signin from "./pages/authentification/Signin";
import ForgotPassword from "./pages/authentification/ForgotPassword";
import ResetPassword from "./pages/authentification/ResetPassword";
import UtilisateurCompte from "./pages/utilisateur/UtilisateurCompte";
import Otp from "./pages/authentification/Otp";
import UtilisisateurProfile from "./pages/utilisateur/UtilisisateurProfile";
import Message from "./pages/message/Message";
import Footer from "./components/footer/Footer";
import MentionLegale from "./components/footer/privacy-policy/MentionsLegales.jsx";
import CgvCgu from "./components/footer/CgvCgu/CgvCgu.jsx";
import ArticleListe from "./pages/article/ArticleListe.jsx";
import ArticleVisualisation from "./pages/article/ArticleVisualisation.jsx";
import ArticleDetail from "./pages/article/ArticleDetail.jsx";
import ArticlePhotosViewer from "./pages/article/ArticlePhotosViewer.jsx";
import NotificationsPage from "./pages/notification/NotificationsPage.jsx";
import Article from "./pages/article/Articles";
import ArticleCreate from "./pages/article/ArticleCreate";
import ArticleUpdate from "./pages/article/ArticleUpdate";
import ArticleRecherche from "./pages/article/ArticleRecherche";
import CallbackMessage from "./pages/callback/CallbackMessage.jsx";
import CallbackPaiement from "./pages/callback/CallbackPaiement.jsx";
import { NotificationProvider } from "./contexts/NotificationContext";
import AdminUsersPage from "./pages/admin/gestionUtilisateur/AdminUsersPage.jsx";
import AdminArticlesPage from "./pages/admin/gestionArticles/AdminArticlesPage.jsx";
import ArticleUpdatePage from "./pages/admin/gestionArticles/AdminUpdatePage.jsx";
import AdminPaiementsPage from "./pages/admin/gestionPaiment/AdminPaiementsPage.jsx";
import PaiementStripe from "./pages/paiement/PaiementStripe.jsx";
import PaiementMesPaiements from "./pages/paiement/PaimentListe.jsx";
import { Elements } from "@stripe/react-stripe-js";
import useStripePaiement from "./hooks/useStripePaiement";
import SupportPage from "./pages/support/SupportPage.jsx";
import AdminCategoriesPage from "./pages/admin/gestionCategorie/CategorieListePage.jsx";
import AdminCategoriesCreationPage from "./pages/admin/gestionCategorie/CategorieCreatePage.jsx";
import AdminCategoriesModificationPage from "./pages/admin/gestionCategorie/CategorieEditPage.jsx";
import ArticlePaiementPage from "./pages/article/ArticlePaiementPage.jsx";
import AdminDashboardPage from "./pages/admin/dashbordAdmin/AdminDashboardPage.jsx";
import AdminSignalementsPage from "./pages/admin/gestionSignalement/AdminSignalementsPage.jsx";
import SignalementCreate from "./pages/signalement/SignalementCreate.jsx";
import AdminSignalementRecapPage from "./pages/signalement/AdminSignalementRecapPage.jsx";
import AdminGroupCategoriePage from "./pages/admin/gestionGroupCategorie/groupCategorie.jsx";
import CallbackSocialConnection from "./pages/callback/CallbackSocialConnection.jsx";
import AdminVisitesPage from "./pages/admin/gestionVisite/AdminVisitesPage.jsx";
import ScrollToTop from "./components/scrollToTop/ScrollToTop.jsx";
import useVisite from "./hooks/useVisite";
import AdminCouponPage from "./pages/admin/gestionCoupons/Coupon.jsx";
import AdminSondageReponse from "./pages/admin/gestionSondage/AdminSondageReponse.jsx";
import AdminSondageQuestion from "./pages/admin/gestionSondage/AdminSondageQuestion.jsx";
import AdminJournalPage from "./pages/admin/gestionJournal/AdminJournalPage.jsx";
import "./assets/css/app/AppLayout.css";

const TrackVisite = () => {
  const location = useLocation();
  const { createVisite } = useVisite();

  useEffect(() => {
    const userStorage =
      localStorage.getItem("user") ||
      localStorage.getItem("utilisateur") ||
      localStorage.getItem("currentUser");

    let utilisateur = null;

    try {
      const parsed = userStorage ? JSON.parse(userStorage) : null;
      utilisateur = parsed?._id || parsed?.id || parsed?.data?._id || null;
    } catch {
      utilisateur = null;
    }

    createVisite({
      path: location.pathname,
      utilisateur,
    }).catch(() => { });
  }, [location.pathname]);

  return null;
};

const AppContent = () => {
  const { stripePromise } = useStripePaiement();
  const { alertMessage } = useContext(AuthContext)
  const haveHeader =
    window.location.pathname === "/connexion" ||
    window.location.pathname === "/inscription" ||
    window.location.pathname === "/mot-de-passe-oublie" ||
    window.location.pathname.startsWith("/reset-password/") ||
    window.location.pathname === "/utilisateur/compte" ||
    window.location.pathname === "/connexion/validation" ||
    window.location.pathname === "/article/creation" ||
    window.location.pathname === "/message/succes" ||
    window.location.pathname === "/article/succes" ||
    window.location.pathname === "/article/modification" ||
    window.location.pathname === "/article/abonnement/paiement" ||
    window.location.pathname.startsWith("/article/") && window.location.pathname.endsWith("/photos") ||
    window.location.pathname === "/admin/signalements/recap" ||
    window.location.pathname.startsWith("/signalement/creation/");

  const is2FAPage = useMatch("/connexion/validation/:userId/:email") !== null;
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [searchValue, setSearchValue] = useState("");

  return (
    <div className="app-shell">
      {alertMessage && (
        <ToastMessage
          type={alertMessage.type}
          message={alertMessage.text}
          onClose={() => setAlert({ type: "", message: "" })}
        />
      )}
      {alert && (
        <ToastMessage
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ type: "", message: "" })}
          style={{ zIndex: "9999999" }}
        />
      )}
      {
        (!haveHeader && !is2FAPage) && <Header setSearchValue={setSearchValue} />
      }
      {/* <ScrollToTop /> */}
      <TrackVisite />

      <main className="app-main">
        <Routes>
          {/* Sans Authentification */}
          <Route path="/" element={<Article />} />
          <Route path="/inscription" element={<GoogleReCaptchaProvider reCaptchaKey={`${process.env.REACT_APP_CLE_SITE}`}><Signin setAlert={setAlert} /></GoogleReCaptchaProvider>} />
          <Route path="/connexion" element={<GoogleReCaptchaProvider reCaptchaKey={`${process.env.REACT_APP_CLE_SITE}`}><Login setAlert={setAlert} /></GoogleReCaptchaProvider>} />
          <Route path="/mot-de-passe-oublie" element={<GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_CLE_SITE}><ForgotPassword setAlert={setAlert} /></GoogleReCaptchaProvider>} />
          <Route path="/reset-password/:userId/:token" element={<GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_CLE_SITE}><ResetPassword setAlert={setAlert} /></GoogleReCaptchaProvider>} />
          <Route path="/connexion/validation/:userId/:email" element={<Otp setAlert={setAlert} />} />
          <Route path="/article/resultat" element={<ArticleRecherche setAlert={setAlert} />} />
          <Route path="/:nomGroup/:nomCategorie" element={<ArticleRecherche setAlert={setAlert} />} />
          <Route path="/article/details/:id" element={<ArticleDetail setAlert={setAlert} />} />
          <Route path="/article/:id/photos" element={<ArticlePhotosViewer setAlert={setAlert} />} />
          <Route path="/contact" element={<SupportPage setAlert={setAlert} />} />
          <Route path="/socialLogin/success" element={<CallbackSocialConnection setAlert={setAlert} />} />
          <Route path="/mentions-legales" element={<MentionLegale setAlert={setAlert} />} />
          <Route path="/cgv-cgu" element={<CgvCgu setAlert={setAlert} />} />

          {/* Authentification Simple utilisateur*/}
          <Route path="/article/creation" element={<Elements stripe={stripePromise}><ProtectedRoute><ArticleCreate setAlert={setAlert} /></ProtectedRoute></Elements>} />
          <Route path="/article/modification" element={<Elements stripe={stripePromise}><ProtectedRoute><ArticleUpdate setAlert={setAlert} /></ProtectedRoute></Elements>} />
          <Route path="/article/visualisation/:id" element={<Elements stripe={stripePromise}><ProtectedRoute><ArticleVisualisation setAlert={setAlert} /></ProtectedRoute></Elements>} />
          <Route path="/utilisateur/compte" element={<ProtectedRoute><UtilisateurCompte setAlert={setAlert} /></ProtectedRoute>} />
          <Route path="/utilisateur/mesAnnonces" element={<ArticleListe setAlert={setAlert} />} />
          <Route path="/utilisateur/profil" element={<ProtectedRoute><UtilisisateurProfile setAlert={setAlert} /></ProtectedRoute>} />
          <Route path="/message/:id" element={<Message setAlert={setAlert} />} />
          <Route path="/message/succes" element={<CallbackMessage setAlert={setAlert} />} />
          <Route path="/article/succes" element={<ProtectedRoute><CallbackPaiement setAlert={setAlert} /></ProtectedRoute>} />
          <Route path="/notification/" element={<ProtectedRoute><NotificationsPage setAlert={setAlert} /></ProtectedRoute>} />
          <Route path="/paiement/stripe" element={<ProtectedRoute><PaiementStripe setAlert={setAlert} /></ProtectedRoute>} />
          <Route path="/paiement/mesPaiements" element={<ProtectedRoute><PaiementMesPaiements setAlert={setAlert} /></ProtectedRoute>} />
          <Route path="/article/abonnement/paiement" element={<Elements stripe={stripePromise}><ProtectedRoute><ArticlePaiementPage setAlert={setAlert} /></ProtectedRoute></Elements>} />
          <Route path="/article/modifier/:id" element={<ProtectedRoute><ArticleUpdatePage setAlert={setAlert} /></ProtectedRoute>} />
          <Route path="/signalement/creation/:id" element={<ProtectedRoute><SignalementCreate setAlert={setAlert} /></ProtectedRoute>} />

          {/* Authentification Administrateur*/}
          <Route path="/admin/utilisateurs" element={<AdminRoute setAlert={setAlert}><AdminUsersPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/articles" element={<AdminRoute setAlert={setAlert}><AdminArticlesPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/paiements" element={<AdminRoute setAlert={setAlert}><AdminPaiementsPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/categories" element={<AdminRoute setAlert={setAlert}><AdminCategoriesPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/groupCategorie" element={<AdminRoute setAlert={setAlert}><AdminGroupCategoriePage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/categories/creation" element={<AdminRoute setAlert={setAlert}><AdminCategoriesCreationPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/categories/modification/:id" element={<AdminRoute setAlert={setAlert}><AdminCategoriesModificationPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/dashboard" element={<AdminRoute setAlert={setAlert}><AdminDashboardPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/signalements" element={<AdminRoute setAlert={setAlert}><AdminSignalementsPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/signalements/recap" element={<AdminRoute setAlert={setAlert}><AdminSignalementRecapPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/visites" element={<AdminRoute setAlert={setAlert}><AdminVisitesPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/sondages" element={<AdminRoute setAlert={setAlert}><AdminSondageReponse setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/sondages/questions" element={<AdminRoute setAlert={setAlert}><AdminSondageQuestion setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/coupons" element={<AdminRoute setAlert={setAlert}><AdminCouponPage setAlert={setAlert} /></AdminRoute>} />
          <Route path="/admin/journal" element={<AdminRoute setAlert={setAlert}><AdminJournalPage setAlert={setAlert} /></AdminRoute>} />
        </Routes>
      </main>

      {
        (!haveHeader && !is2FAPage) && <Footer />
      }
    </div>
  )
}

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <AppContent />
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;